import { useNavigate } from 'react-router-dom'
import { KTIcon } from '../../../../../_metronic/helpers'
import useAuthorization from '../../../../../hooks/useAuthorization'

const Toolbar = () => {
    const navigate = useNavigate()
    const addUserModal = () => navigate('/people/create')
    const isAuthorizedToCreate = useAuthorization("persons.create")
    if (!isAuthorizedToCreate) return <></>

    return (
        <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
            {/* begin::Add user */}
            <button type='button' className='btn btn-light-danger' onClick={addUserModal}>
                <KTIcon iconName='plus' className='fs-2' />
                Adicionar Cliente
            </button>
            {/* end::Add user */}
        </div>
    )
}

export { Toolbar }
